import React from 'react';
import ImageUploading from 'react-images-uploading';
import { Modal, Button, useToaster, Message } from 'rsuite';
import './image-style.css';
import Drag from './drag-and-drop.jpg';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import Port from '../../../Port';
const { hostname } = window.location;
// const hostname = '192.168.1.19';
const SmartSearchModal = ({
  open,
  close,
  setData123,
  setStopInfininitescrol,
  setTableData,
  setCurrentPage,
  setImagesearchedids
}) => {
  const [images, setImages] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const toaster = useToaster();
  const maxNumber = 69;
  const onChange = imageList => {
    setImages(imageList);
  };
  const handleSearchImage = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('filterImage', images[0].file);
    formData.append('threshold', '140');
    const res = await axios.post(
      `http://${hostname}${Port.smartsearchip}/api/upload-image`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    const { sameId } = res.data;
    console.log('sameId');
    console.log(sameId);
    if (sameId.length) {
      // setCurrentPage(1);
      setImagesearchedids(sameId);
      // setData123([]);
      // const promises = sameId.map(async id => {
      //   const { data } = await axios.get(`${globalIP}/api/products/${id}?populate=*`);
      //   return data.data;
      // });
      // const allData = await Promise.all(promises);
      // setData123(allData);
      // setTableData(allData);
      close();
    } else {
      // setCurrentPage(1);
      // setData123([]);
      toaster.push(
        <Message showIcon type="error">
          Not Found.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    setIsLoading(false);
  };
  return (
    <>
      <Modal
        overflow={false}
        open={open}
        onClose={() => {
          close();
          setStopInfininitescrol(true);
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ textAlign: 'center', fontSize: '20px', fontWeight: '400' }}>
            Search any image with Google Lens
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="App">
            <ImageUploading
              value={images}
              onChange={onChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({ imageList, onImageUpload, isDragging, dragProps }) => (
                <div className="upload__image-wrapper">
                  <button
                    style={isDragging ? { color: 'red', fontSize: '20px' } : { fontSize: '20px' }}
                    onClick={onImageUpload}
                    {...dragProps}
                    className="image-uploader"
                  >
                    {imageList.length ? null : (
                      <>
                        <img src={Drag} alt="" style={{margin:"auto"}} />
                        Drag an image here or upload a file
                      </>
                    )}
                    {imageList.map((image, index) => (
                      <div key={index} className="image-item">
                        <img
                          src={image['data_url']}
                          alt=""
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                      </div>
                    ))}
                  </button>
                </div>
              )}
            </ImageUploading>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="primary"
            disabled={images.length ? false : true}
            color="cyan"
            onClick={handleSearchImage}
            loading={isLoading}
          >
            Search
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SmartSearchModal;
